export default __webpack_public_path__ + "static/media/risk_head_purple_bg.c3eb8ab3.png";